module.exports = __webpack_public_path__ + "img/jp_matcha.2240b123.jpg";